/**
 * @type {import('next-i18next').UserConfig}
 * */
const i18nConfig = {
  i18n: {
    locales: ["fr", "de"],
    defaultLocale: "fr",
    localeDetection: false,
  },
  interpolation: { escapeValue: false },
  fallbackLng: false,
  defaultNS: "common",
  ns: [
    "common",
    "home",
    "expert",
    "faq",
    "member",
    "horoscope",
    "terms",
    "packs",
    "ticket",
    "livechat",
    "settings",
    "favorites",
    "messages",
    "support",
    "planning",
    "blog",
  ],
  serializeConfig: false,
  saveMissing: true,
};

module.exports = i18nConfig;
